var exports = {
  "l5": "errorPointerBox__e79pas",
  "Ye": "errorBox__Lbzoh1",
  "mZ": "flexSpacer__pO42ye",
  "FU": "successIcon__M_acVl",
  "ui": "failureIcon__ZfsDSa",
  "R7": "completedIcon__b4A1JU",
};

module.exports = exports;
